import React from "react";

const FilterByCoachConf = ({
  store,
  coachData = { teams: [], conf: [], isDisplayed: false },
  toggleCoachConference = null,
}) => {
  return store?.isSignUpCoach ? (
    coachData["teams"].length > 0 && coachData["confName"].length > 0 && !coachData["isDisplayed"] ? (
      <button className="btn btn-primary conferencesBtn" onClick={toggleCoachConference}>
        Show {coachData["confName"]} Conferences
      </button>
    ) : (
      <button
        className="btn btn-primary conferencesBtn"
        onClick={toggleCoachConference}
        disabled={coachData["teams"].length > 0 ? false : true}
      >
        Show All Conferences
      </button>
    )
  ) : null;
};

export default FilterByCoachConf;
